import React, { useEffect, useState } from "react";
import { OneBtnModal } from "components/common/modal";
import { PrimaryBtn } from "components/common/button";
import {
  ChannelDropdown,
  TemplateDropdown,
  VariableInput,
} from "components/alimtalk";
import {
  postKakaoChannel,
  postTemplate,
  postSendMsg,
} from "service/api/alimtalk";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { IChannelList, ITemplateList } from "service/interface/alimtalk";

export function AlimtalkPage() {
  const [isSuccessModalVisible, setISuccessModalVisible] =
    useState<boolean>(false);
  const [channelList, setChannelList] = useState<IChannelList[]>([]);
  const [selectChannel, setSelectChannel] = useState<{
    id: string;
    name: string;
  }>({} as { id: string; name: string });
  const [templateList, setTemplateList] = useState<ITemplateList[]>([]);
  const [selectTemplate, setSelectTemplate] = useState<{
    id: number;
    name: string;
  }>({} as { id: number; name: string });
  const [variableList, setVariableList] = useState<any>([]);
  const [receiver, setReceiver] = useState<string>("");
  const [selectInfo, setSelectInfo] = useState<{
    senderkey: string;
    tpl_code: string;
    subject: string;
    button: string;
  }>();

  useEffect(() => {
    (async () => {
      const channelRes = await postKakaoChannel();
      setChannelList(channelRes.data.list);
    })();
  }, []);

  useEffect(() => {
    if (selectTemplate?.name) {
      const regex = /#\{(.*?)\}/g;
      const matches = templateList[selectTemplate.id].templtContent
        .match(regex)
        ?.map((item) => item.slice(2, -1));
      matches?.length !== 0 &&
        setVariableList((prev: any) =>
          matches?.map((list) => ({ id: list, content: "" })),
        );
      setSelectInfo({
        senderkey: templateList[selectTemplate.id].senderKey,
        tpl_code: templateList[selectTemplate.id].templtCode,
        subject: templateList[selectTemplate.id].templtName,
        button: JSON.stringify({
          button: templateList[selectTemplate.id].buttons,
        }),
      });
    }
  }, [selectTemplate]);

  const handleChannel = async (id: any) => {
    setSelectChannel(id);
    setSelectTemplate({} as { id: number; name: string });
    setVariableList([]);
    setReceiver("");
    const res = await postTemplate(id.id);
    setTemplateList(res.data.list);
  };

  const handleTemplate = (item: any) => {
    setSelectTemplate(item);
  };

  const handleReceiverInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReceiver(e.target.value);
  };

  const handleVariableInput = (idx: number, text: string) => {
    let copiedArr = [...variableList];
    copiedArr[idx].content = text;
    setVariableList(copiedArr);
  };

  const handleSendBtn = async () => {
    const indexTracker: any = {};
    const resultMessage = templateList[selectTemplate.id].templtContent.replace(
      /#\{(.*?)\}/g,
      (match, p1) => {
        let replacements = variableList.filter((item: any) => item.id === p1);
        if (!indexTracker[p1]) {
          indexTracker[p1] = 0;
        }
        let contentIndex = indexTracker[p1];
        let replacement = replacements[contentIndex];
        indexTracker[p1] = (contentIndex + 1) % replacements.length;
        return replacement ? replacement.content : match;
      },
    );
    await postSendMsg({
      senderkey: selectInfo?.senderkey,
      tpl_code: selectInfo?.tpl_code,
      receiver: receiver,
      subject: selectInfo?.subject,
      message: resultMessage,
      button: selectInfo?.button,
    })
      .then(() => {
        setISuccessModalVisible(true);
      })
      .catch(() => {
        alert("Server Error");
      });
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setISuccessModalVisible}
        title="전송 완료"
        subTitle="전송이 완료 되었습니다."
        btnLabel="확인"
        btnClick={() => {}}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              알림톡 메시지 발송
            </p>
          </div>
          <div className="mt-[32px] flex flex-col gap-[24px] rounded-[12px] bg-white p-[48px_40px_103px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <ChannelDropdown
              label="카카오채널 ID"
              menuList={channelList.map((list) => ({
                id: list.senderKey,
                name: list.uuid,
              }))}
              selectMenu={selectChannel}
              onClick={handleChannel}
            />
            <TemplateDropdown
              label="템플릿 선택"
              menuList={templateList.map((list, idx) => ({
                id: idx,
                name: list.templtName,
              }))}
              selectMenu={selectTemplate}
              onClick={handleTemplate}
            />
            <div className="flex flex-col gap-[12px]">
              <VariableInput
                label="전화번호"
                value={receiver}
                onChange={handleReceiverInput}
              />
              {variableList?.length !== 0 && (
                <>
                  {variableList?.map((list: any, idx: number) => (
                    <VariableInput
                      label={`#{ ${list.id} }`}
                      value={list.content}
                      onChange={(e) => handleVariableInput(idx, e.target.value)}
                    />
                  ))}
                </>
              )}
            </div>
            <div>
              <div className="mt-[15px] flex justify-end">
                <PrimaryBtn
                  isDisabled={!selectInfo?.senderkey || !receiver}
                  label="전송하기"
                  onClick={handleSendBtn}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
